import locale from '../locale/default';
export default locale;
//# sourceMappingURL=default.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/locale-provider/default.js
// module id = 795
// module chunks = 0